// Cadence-health color mapping — FE-SCRM-008.
//
// Spec line 597: red = critical, orange = behind, green = on_track,
// blue = ahead, grey = not_yet_urgent. Tailwind class names so cards
// and tiles render the same border without ad-hoc inline styles.

import type { CadenceHealth } from "./types";


export const CADENCE_BORDER: Record<CadenceHealth, string> = {
  critical: "border-l-4 border-ember",
  behind: "border-l-4 border-amber",
  on_track: "border-l-4 border-sage",
  ahead: "border-l-4 border-teal",
  not_yet_urgent: "border-l-4 border-border-subtle",
};


export const CADENCE_BG_DOT: Record<CadenceHealth, string> = {
  critical: "bg-ember",
  behind: "bg-amber",
  on_track: "bg-sage",
  ahead: "bg-teal",
  not_yet_urgent: "bg-border-subtle",
};


export const CADENCE_LABEL: Record<CadenceHealth, string> = {
  critical: "Critical",
  behind: "Behind",
  on_track: "On track",
  ahead: "Ahead",
  not_yet_urgent: "Not yet urgent",
};


// Total-width distribution-bar ordering (left-to-right). Critical-first
// matches the visual emphasis the spec calls out.
export const CADENCE_DISTRIBUTION_ORDER: CadenceHealth[] = [
  "critical", "behind", "on_track", "ahead", "not_yet_urgent",
];
